import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewContainerRef,
} from '@angular/core';
import { Cooperative } from '../../../models/cooperatives';
import { environment } from '../../../../environments/environment';
import { Onboarding, OnbValidators } from '../../../models/onboarding';
import { ApiService } from '../../../services/api.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { from } from 'rxjs/observable/from';
import { catchError, tap } from 'rxjs/operators';
import { UtilsService } from '../../../services/utils.service';
import { ModalDialogService } from 'ngx-modal-dialog';
import { LinkInfo } from '../../../models/link_info';
import { AlgConditionModalComponent } from '../../dialogs/alg-condition-modal/alg-condition-modal.component';

@Component({
  selector: 'alg-coop-membership-card',
  templateUrl: './alg-coop-membership-card.component.html',
  styleUrls: ['./alg-coop-membership-card.component.scss'],
})
export class AlgCoopMembershipCardComponent implements OnInit {
  @Output() isCoopMemberRegistry = new EventEmitter<boolean>();
  @Output() socioCode = new EventEmitter<string>();
  @Output() validationOutcome = new EventEmitter<{
    cardValidationOutcome: string;
    cardValidationDescription: string;
    contractsMemberOutcome: string;
  }>();
  public currentOnboarding: Onboarding = {} as Onboarding;
  public cooperatives: Cooperative[];
  public imageUrl: string;
  public codeCardError: boolean;
  public isCodeCardValid: boolean;
  public maxLength: number = 13;
  public eanCode: string;
  public errorMessage: string;
  public coopCf: string;
  public membershipCardForm: FormGroup;
  public isAvailableCheckCardCode: boolean;
  public regexLibrettoCode: string =
    '^(0240|0241|0244|0245|0260|0262|0250|0251|0252|0253|0265|0269)[0-9]{9}$';
  public linkInfoLabel: string;
  public linkInfoDescription: string;
  public backCard: string;

  constructor(
    private api: ApiService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    this.api.currentOnboarding.subscribe((onboarding) => {
      this.currentOnboarding = onboarding;
    });
    this.api.cooperatives.subscribe((cooperatives: Cooperative[]) => {
      this.cooperatives = cooperatives;
      this.backCard = this.cooperatives[1].backCard.filename;
    });
    this.membershipCardForm = new FormGroup({
      checkFormatCode: new FormControl(this.currentOnboarding.codeCard, {
        validators: [
          Validators.required,
          Validators.pattern(this.regexLibrettoCode),
        ],
      }),
    });
    this.imageUrl = environment.imageUrl;
  }

  checkLength(event: any) {
    if (event.target.value.length >= this.maxLength) {
      event.preventDefault();
    }
  }

  addFormControls() {
    this.membershipCardForm
      .get('checkFormatCode')
      .setValidators([
        Validators.required,
        Validators.pattern(this.regexLibrettoCode),
        OnbValidators.sameCf(this.currentOnboarding.cf, this.coopCf),
      ]);
  }

  handlerCoopMemberRegistryResponse(data) {
    console.log({ data });
    this.isAvailableCheckCardCode = true;
    console.log('onboarding', this.currentOnboarding);
    this.coopCf = '';
    if (data === 'KO') {
      this.isCoopMemberRegistry.emit(false);
      console.log('NO SOCIO', data);
      this.addFormControls();
      this.membershipCardForm.get('checkFormatCode').updateValueAndValidity();
      this.isCodeCardValid = false;
      this.codeCardError = true;
      this.errorMessage = 'CODICE_TESSERA_INVALID';
    } else if (data.success === false) {
      this.addFormControls();
      this.errorMessage = 'SERVICE_CHECK_CF_ACCENDI_UNICA_COOP';
      this.isAvailableCheckCardCode = false;
      this.codeCardError = true;
      this.isCodeCardValid = false;
      this.membershipCardForm.get('checkFormatCode').updateValueAndValidity();
    } else {
      this.coopCf = data.socio.anagrafica.codice_fiscale;
      this.addFormControls();
      if (this.coopCf !== this.currentOnboarding.cf) {
        this.membershipCardForm.get('checkFormatCode').updateValueAndValidity();
        this.isCodeCardValid = false;
        this.isCoopMemberRegistry.emit(false);
        this.errorMessage = 'ERROR_CF_SOCIO_CODE';
      } else {
        this.membershipCardForm.get('checkFormatCode').updateValueAndValidity();
        const outcome = {
          cardValidationOutcome: 'OK',
          cardValidationDescription: `${data.return_code.error_msg}`,
          contractsMemberOutcome: 'OK',
        };
        this.validationOutcome.emit(outcome);
        this.isCoopMemberRegistry.emit(true);
        this.socioCode.emit(this.eanCode);
        this.isCodeCardValid = true;
      }
    }
  }

  checkSocioCoop(code) {
    return from(this.api.checkCoopMemberRegistry(code))
      .pipe(
        tap((res) => {
          this.handlerCoopMemberRegistryResponse(res);
        }),
        catchError((err) => {
          console.log({ err });
          throw err;
        })
      )
      .toPromise();
  }

  checkValidSocioCode() {
    this.isAvailableCheckCardCode = true;
    const patt1 = new RegExp(this.regexLibrettoCode);
    const codeCardValue = this.membershipCardForm.get('checkFormatCode').value;
    this.eanCode = codeCardValue;
    if (
      this.isAvailableCheckCardCode &&
      codeCardValue.length > 0 &&
      codeCardValue.length < this.maxLength &&
      !patt1.test(codeCardValue)
    ) {
      this.errorMessage = 'ERROR_SOCIO_CODE_LENGTH';
      this.codeCardError = true;
    } else if (
      this.isAvailableCheckCardCode &&
      codeCardValue.length === this.maxLength &&
      !patt1.test(codeCardValue)
    ) {
      this.errorMessage = 'CODICE_TESSERA_INVALID';
      this.codeCardError = true;
    } else if (this.isAvailableCheckCardCode && codeCardValue.length === 0) {
      this.codeCardError = true;
    } else {
      this.checkSocioCoop(codeCardValue);
      this.codeCardError = false;
    }
  }

  openModal() {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: LinkInfo(this.linkInfoLabel).title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: this.linkInfoDescription,
      },
    });
  }

  openLink() {
    this.linkInfoLabel = 'codice_tessera';
    this.linkInfoDescription = `<img src='${this.imageUrl}${this.backCard}' alt='card' title='card' />`;

    this.openModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-coop-membership-card/alg-coop-membership-card.component.ts